import { createStore, combineReducers } from "redux";
import app from "./app/reducers";
import option from "./option/reducers";
import devTools from "./devTools/reducers";

// Классический redux (без toolkit) — по конвенции EPS.
export const store = createStore(
    combineReducers({ app, option, devTools }),
    (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__)
        ? window.__REDUX_DEVTOOLS_EXTENSION__()
        : undefined,
);
